import React, { FC } from 'react';
import './TaskForm.css';
import {
	InputField,
	SelectField,
	RequiredNote,
	FaTasks,
	DomainFormProps
} from '@/Shared';

/**
 * =====================================================
 * Component: TaskForm
 * =====================================================
 *
 *
 * Domain-specific form UI for Task.
 * Mounted inside GenericDomainForm.
 *
 * Responsibilities:
 * - Render task fields
 * - Use data from formVM (options, values)
 *
 * No permissions, no loading, no orchestration logic here.
 *
 * Author: Samano CASTRE
 * Date: February 15, 2026
 */
const TaskForm: FC<DomainFormProps> = ({
	domainFormHook,
	formRef,
}) => {

	const { entityFormVM } = domainFormHook;

	/**
	 * =====================================================
	 * Main Form Rendering
	 * =====================================================
	 *
	 * Fieldsets organize the form into logical sections for clarity.
	 */
	return (

		<div className="fieldset-wrapper">

			<fieldset className='width-30'>
				<legend>Caractéristiques Générales</legend>
				<SelectField
					label='Catégorie de tâche'
					required
					icon={<FaTasks />}
					name='category'
					options={entityFormVM.getCategoryOptions()}
					scrollParent={formRef.current}
				/>
				<InputField
					label='Label'
					required
					icon={<FaTasks />}
					name='label'
					placeholder='Saisir le titre de la tâche'
					autoComplete='on' />

				<RequiredNote />
			</fieldset>
		</div>
	);
}
export default TaskForm;